import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { MealMonitoringEntity } from '../../domain/entities/MealMonitoringEntity'
import type { MealMonitoringAdminDto } from '@/backend/market'

export class MealMonitoringModel extends MealMonitoringEntity {
  constructor(dataDto: MealMonitoringAdminDto) {
    super()
    mapEntityProperties<MealMonitoringEntity>(this, dataDto, {
      map: {
        referenceCode: dataDto.referenceCode,
        mealBranches: dataDto.mealBranches?.map((branch) => ({
          id: branch.id,
          name: branch.branch?.name,
          status: branch.status,
          estimatedItemsPreparationTime: branch.estimatedItemsPreparationTime
        }))
      }
    })
  }
}
